import {
	SAVE_PATIENT_NOTE_SUCCESS,
	SAVE_PATIENT_NOTE_REQUEST,
	SAVE_PATIENT_NOTE_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
}

const savePatientNoteReducer = (state = initialState, action) => {
	switch (action.type) {
		case SAVE_PATIENT_NOTE_SUCCESS:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case SAVE_PATIENT_NOTE_REQUEST:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case SAVE_PATIENT_NOTE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default savePatientNoteReducer